/**
 * A simple and flexible context menu component. Drop it in any component to override default right click behavior
 * and display a custom menu. Has its own <MenuItem> component that takes an onClick handler and a label as children.
 * 
 * @example
 * 
 * <ContextMenu>
 *   <ContextMenu.MenuItem onClick={this._doStuff}>
 *     Do stuff!
 *   </ContextMenu.MenuItem>
 *   <ContextMenu.MenuItem onClick={this._doOtherStuff}>
 *     Do other stuff!
 *   </ContextMenu.MenuItem>
 * </ContextMenu>
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Base from "../BaseComponent.js.jsx";

class ContextMenu extends Base {
  constructor(props) {
    super(props);
    this.state = {
      xPos: "0px"
      , yPos: "0px"
      , isOpen: false
    }
  }

  componentDidMount() {
    document.addEventListener("click", this._handleClick);
    document.addEventListener("contextmenu", this._handleContextMenu);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this._handleClick);
    document.removeEventListener("contextmenu", this._handleContextMenu);
  }

  _handleClick = (e) => {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  _handleContextMenu = (e) => {
    e.preventDefault();

    this.setState({
      xPos: `${e.pageX}px`
      , yPos: `${e.pageY}px`
      , isOpen: true
    });
  }


  render() {
    if(this.state.isOpen) {
      return (
        <ul className="context-menu" style={{
          position: "absolute"
          , top: this.state.yPos
          , left: this.state.xPos
        }}>
          {this.props.children}
        </ul>
      )
    }
    return null;
  }
}

ContextMenu.MenuItem = ({ children, ...props }) => {
  return (
    <li {...props}>
      {children}
    </li>
  )
}

ContextMenu.propTypes = {
  children: PropTypes.object.isRequired
}

export default ContextMenu


// WEBPACK FOOTER //
// global/components/helpers/ContextMenu.js.jsx